<template>
  <div id="totals" class="border-padding">
  <main>
    <div v-if="$route.params.type == 'player'">
      <h2>Player Game Logs</h2>
    </div>
    <div v-if="$route.params.type == 'team'">
      <h2>Team Game Logs</h2>
    </div>
    <div v-if="$route.params.type == 'opponent'">
      <h2>Opponent Game Logs</h2>
    </div>
    <div v-if="$route.params.type == 'lineup'">
      <h2>Lineup Game Logs</h2>
    </div>
    <div v-if="$route.params.type == 'lineup-opponent'">
      <h2>Lineup Opponent Game Logs</h2>
    </div>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined && $route.params.type != 'lineup' && $route.params.type != 'lineup-opponent'">
        <team-select v-model="team_selected" :options="team_dropdown" :inputFunc="changePlayers" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-2" v-if="players.length > 0">
        <player-select v-model="player_selected" :options="players" label="Player"></player-select>
      </div>

    </div>

    <div v-if="$route.params.type != 'lineup' && $route.params.type != 'lineup-opponent'" class="border-padding">
      <button class="" v-on:click="changeStats()">Get Stats</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data_options.length > 0">
      <div class="row">
        <div class="col-md-2" v-if="stat_type_dropdown.data != undefined">
          <stat-type-select
            v-model="stat_type_selected"
            :options="stat_type_dropdown"
            :summary_table_data="single_row_table_data"
            :table_data="multi_row_table_data"
            :summary_totals="single_row_table_data_totals"
            :totals="multi_row_table_data_totals"
            :summary_per_100="single_row_table_data_per_100"
            :table_per_100="multi_row_table_data_per_100"
            :stat_table_data_options="table_data_options"
            :summary_columns="single_row_table_columns"
            :columns="multi_row_table_columns"
            :stat_type_change_func="changeStatType">
          </stat-type-select>
        </div>
        <div class="col-md-2">
          <stat-table-select v-model="stat_table_selected" :options="table_data_options"></stat-table-select>
        </div>
      </div>
      <div v-if="stat_table_selected != undefined && multi_row_table_data[stat_table_selected.id] != undefined">
        <div>
          <button type="button" @click="copyDirectLink">Copy Direct Link To Table</button>
        </div>
        <vue-good-table
          :columns="multi_row_table_columns[stat_table_selected.id]"
          :rows="multi_row_table_data[stat_table_selected.id]"
          :pagination-options="{ enabled: true, perPage: 30}"
          :searchOptions="{ enabled: false}"
          :sort-options="{ enabled: true, initialSortBy: {field: 'Date', type: 'asc'}}"
          :line-numbers="true"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'Date'">
              <span :id="'popover-' + props.row.GameId + '-'+stat_table_selected.id" v-b-tooltip.hover title="Click For More">
                {{props.formattedRow[props.column.field]}}
              </span>
              <b-popover
                :target="'popover-' + props.row.GameId + '-'+stat_table_selected.id">
                <template slot="title">{{props.row.Date}}</template>
                <ul>
                  <li><router-link :to="{ name: 'game_stats', params: { game_id: props.row.GameId, type: 'player' }}">Player Game Stats</router-link></li>
                  <li><router-link :to="{ name: 'game_stats', params: { game_id: props.row.GameId, type: 'lineup' }}">Lineup Game Stats</router-link></li>
                  <li><router-link :to="{ name: 'game_stats', params: { game_id: props.row.GameId, type: 'lineup-opponent' }}">Lineup Opponent Game Stats</router-link></li>
                  <li v-if="$route.params.type == 'team'"><router-link :to="{ name: 'assist_networks', params: { type: 'game', league: $route.params.league }, query: { GameId: props.row.GameId, TeamId: $route.query.EntityId }}">Assist Network</router-link></li>
                </ul>
              </b-popover>
            </div>
            <div v-else>
              <span v-b-tooltip.hover :title="props.formattedRow['Name']">
                {{props.formattedRow[props.column.field]}}
              </span>
            </div>
          </template>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
              {{props.column.label}}
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
        </vue-good-table>

        <div v-if="single_row_table_data.Points != undefined">
          <h2>Totals</h2>

          <vue-good-table
            :columns="single_row_table_columns[stat_table_selected.id]"
            :rows="[single_row_table_data]"
            :searchOptions="{ enabled: false}"
            :sort-options="{ enabled: false}"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.formattedRow[props.column.field] == ''">
                0
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
              </span>
              <span v-else>
                {{props.column.label}}
              </span>
            </template>
          </vue-good-table>
        </div>

        <div v-if="multi_row_table_data[stat_table_selected.id] != undefined">
          <vue-csv-downloader
            :data="multi_row_table_data[stat_table_selected.id]"
            :fields="csvHeaders"
            download-name="pbpstats_export.csv">
            Export CSV
          </vue-csv-downloader>
        </div>
      </div>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import VueCsvDownloader from 'vue-csv-downloader'
import { rateStats } from './mixins/rate_stats'
import { statTypeOptions } from './mixins/stat_type_options'
import { tableDataOptions } from './mixins/table_data_options'
import { tableUtils } from './mixins/table_utils'
import { gameLogsHeaders } from './mixins/table_headers'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import PlayerSelect from './mixins/PlayerSelect.vue'
import StatTypeSelect from './mixins/StatTypeSelect.vue'
import StatTableSelect from './mixins/StatTableSelect.vue'
import { season, seasonType } from './mixins/dropdowns'

export default {
  name: 'GameLogs',
  components: {
    Multiselect,
    VueCsvDownloader,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PlayerSelect,
    StatTypeSelect,
    StatTableSelect
  },
  mixins: [
    rateStats,
    statTypeOptions,
    tableDataOptions,
    tableUtils,
    gameLogsHeaders,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PlayerSelect,
    StatTypeSelect,
    StatTableSelect,
    GetDropdownOptions,
    season,
    seasonType
  ],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      stat_type_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_selected_string: '',
      players: [],
      player_selected: undefined,
      table_data_options: [],
      team_dropdown: {},
      team_selected: undefined,
      stat_type_selected: undefined,
      single_row_table_data: [],
      single_row_table_columns: {},
      multi_row_table_data: {},
      multi_row_table_columns: {},
      use_min_filters: false,
      use_text_filters: true,
      show_error_message: false,
      stat_table_selected: undefined,
      direct_link: '',
      api_endpoint: 'get-game-logs/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague',
    'stat_table_selected': 'updateDirectLink',
    'stat_type_selected': 'updateDirectLink'
  },
  methods: {
    resetData () {
      this.single_row_table_data = []
      this.multi_row_table_data = {}
      this.seasons_selected = []
      this.season_selected_string = ''
      this.team_selected = undefined
      this.multi_row_table_data = []
      this.single_row_table_data = []
      this.multi_row_table_data_totals = []
      this.multi_row_table_data_per_100 = []
      this.single_row_table_data_totals = []
      this.single_row_table_data_per_100 = []
    },
    changeLeague () {
      this.resetData()
      this.$router.push({name: 'game_logs', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    setPlayers () {
      if (this.$route.params.type !== 'player') {
        this.players = []
      } else {
        this.changePlayers()
      }
    },
    checkIfStatsShouldBeLoaded () {
      if (this.seasons_selected.length > 0 && this.season_type_selected && this.$route.query.EntityId) {
        this.getStats()
      }
    },
    loadData () {
      this.resetData()
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.setPlayers, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.EntityId) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changePlayers () {
      if (this.$route.params.type === 'player' && this.team_selected) {
        this.getPlayersForTeam()
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.team_selected) {
        if (this.$route.params.type === 'team' || this.$route.params.type === 'opponent') {
          params[this.$entityIdParam] = this.team_selected.id
        } else if (this.$route.params.type === 'player') {
          params[this.$entityIdParam] = this.player_selected.playerId
        }
      }

      this.$router.push({name: 'game_logs', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.multi_row_table_data = {}
      this.single_row_table_data = []
      this.multi_row_table_data_totals = []
      this.multi_row_table_data_per_100 = []
      this.single_row_table_data_totals = []
      this.single_row_table_data_per_100 = []

      var params = this.$route.query

      if (this.$route.params.type === 'team') {
        params[this.$entityTypeParam] = 'Team'
      } else if (this.$route.params.type === 'player') {
        params[this.$entityTypeParam] = 'Player'
      } else if (this.$route.params.type === 'lineup') {
        params[this.$entityTypeParam] = 'Lineup'
      } else if (this.$route.params.type === 'opponent') {
        params[this.$entityTypeParam] = 'Opponent'
      } else if (this.$route.params.type === 'lineup-opponent') {
        params[this.$entityTypeParam] = 'LineupOpponent'
      }

      if (params.Season && params.SeasonType && params.EntityId) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.single_row_table_data = response.data.single_row_table_data
              this.single_row_table_data_totals = response.data.single_row_table_data
              this.multi_row_table_data_totals = response.data.multi_row_table_data

              if (this.$route.params.type === 'team' || this.$route.params.type === 'opponent') {
                var glHeaders = this.team_game_logs_header
                var totalsHeaders = this.team_totals_header
              } else if (this.$route.params.type === 'player') {
                glHeaders = this.player_game_logs_header
                totalsHeaders = this.player_totals_header
              } else if (this.$route.params.type === 'lineup' || this.$route.params.type === 'lineup-opponent') {
                glHeaders = this.lineup_game_logs_header
                totalsHeaders = this.lineup_totals_header
              }

              this.single_row_table_columns = totalsHeaders
              this.multi_row_table_columns = glHeaders

              if (this.$route.params.type === 'player') {
                var tableOptions = this.table_options_with_number_of_fouls
              } else {
                tableOptions = this.base_table_options
              }
              this.table_data_options = tableOptions
              this.stat_type_dropdown = this.options_without_per_game

              this.multi_row_table_data_totals.forEach((row) => {
                this.table_data_options.forEach((tableDataOption) => {
                  var values = this.setZerosAndSortFunction(this.multi_row_table_columns[tableDataOption.id], row)
                  row = values.row
                  this.multi_row_table_columns[tableDataOption.id] = values.columns
                })
              })

              // this sets player and team dropdown when page is loaded via direct link so that they aren't just the first option
              if (this.$route.params.type === 'player') {
                if (this.team_selected.text !== this.multi_row_table_data_totals[this.multi_row_table_data_totals.length - 1].Team) {
                  this.team_dropdown.data.forEach((team) => {
                    if (team.text === this.multi_row_table_data_totals[this.multi_row_table_data_totals.length - 1].Team) {
                      this.team_selected = team
                    }
                  })
                  this.changePlayers()
                }
              }
            } else {
              this.show_error_message = true
              this.single_row_table_data = {}
              this.single_row_table_data_totals = []
            }
            this.loading = false
            this.setStatTypeValue()
            this.changeStatType()
            if (this.$route.query.Table) {
              this.setStatTableSelected()
            }
            this.updateDirectLink()
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    copyDirectLink: function () {
      this.$copyText(this.direct_link)
    },
    updateDirectLink () {
      var query = this.$route.query

      if (this.stat_table_selected) {
        query['Table'] = this.stat_table_selected.id
      }
      if (this.stat_type_selected) {
        query['StatType'] = this.stat_type_selected.id
      }

      var queryString = Object.keys(query).map(function (key) {
        return key + '=' + query[key]
      }).join('&')

      this.direct_link = window.location.origin + this.$route.path + '?' + queryString
    }
  },
  computed: {
    csvHeaders: function () {
      var headers = []
      this.multi_row_table_columns[this.stat_table_selected.id].forEach((column) => {
        headers.push(column.field)
      })
      return headers
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/GameLogs.vue